import { z } from 'zod';

import { Contact } from './common';

export const HelpContact = Contact;
export type HelpContact = z.infer<typeof HelpContact>;

export const HelpContacts = z.array(HelpContact).default([]);
export type HelpContacts = z.infer<typeof HelpContacts>;
